export default "__VITE_ASSET__DUZeCAUX__"